<template>
  <div v-if="project">
    <ProjectLocationsMap v-if="isPublicOrMember" />
    <RequiresMember v-else page="Map"></RequiresMember>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import RequiresMember from "../tabpermission/requiresMember.vue";
import ProjectLocationsMap from "./ProjectLocationsMap.vue";

export default {
  components: {
    RequiresMember,
    ProjectLocationsMap,
  },
  created() {},
  computed: {
    ...mapGetters({
      project: "project/get/project",
      isPublicOrMember: "project/get/isPublicOrMember",
      isManager: "project/get/isManager",
    }),
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
